import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon42: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 16.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 16 20" width={width} height={height} {...props}>
      <Path
        d="M10.003 0C11.106 0 12 0.893986 12 1.99799V3H14.46L14.5 2.99701L14.541 2.99899L15.5 3C15.776 3 16 3.224 16 3.5C16 3.776 15.776 4 15.5 4H15V16.024C15 18.152 13.327 19.889 11.225 19.992L11.027 19.997H4.97301C2.77901 19.997 1 18.218 1 16.024V4H0.5C0.255 4 0.0499956 3.823 0.00799561 3.59L0 3.5C0 3.224 0.224 3 0.5 3H1.46001L1.5 2.99701L1.541 2.99899L4 3V1.99799C4 0.943986 4.81401 0.0820049 5.84801 0.00500488L5.99699 0H10.003ZM14 4H2V16.024C2 17.607 3.238 18.902 4.798 18.992L4.97301 18.997H11.027C12.669 18.997 14 17.666 14 16.024V4ZM4.5 6C4.776 6 5 6.224 5 6.5V16.5C5 16.776 4.776 17 4.5 17C4.224 17 4 16.776 4 16.5V6.5C4 6.224 4.224 6 4.5 6ZM8 6C8.276 6 8.5 6.224 8.5 6.5V16.5C8.5 16.776 8.276 17 8 17C7.724 17 7.5 16.776 7.5 16.5V6.5C7.5 6.224 7.724 6 8 6ZM11.5 6C11.776 6 12 6.224 12 6.5V16.5C12 16.776 11.776 17 11.5 17C11.224 17 11 16.776 11 16.5V6.5C11 6.224 11.224 6 11.5 6ZM10.003 1H5.99699C5.44599 1 5 1.44599 5 1.99799V3H11V1.99799C11 1.48599 10.615 1.06399 10.119 1.00699L10.003 1Z"
        fill="#A84A76"
      />
    </Icon>
  )
}
